export const SALES_DEAL_PIPELINE = 'default'; // sales pipeline

export const TAXES_DEAL_PIPELINES = [
  '21867877', // test taxes pipeline
  '16813355', // prod taxes pipeline
];

export const R_AND_D_DEAL_PIPELINES = [
  '54014362', // prod R&D / ERC Tax Credits pipeline
  '720007079', // test R&D / ERC Tax Credits pipeline
];

export const FRAC_CFO_DEAL_PIPELINE = [
  '47446845', // Frac CFO pipeline prod - doesn't exists in test
];

export const linkValidStatusForTaxesOrRAndD = [
  'closedwon',
  'churned',
  'completed',
];
